
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import AppPanel from '../fw/AppPanel.react';

import types from '../../common/model-api/types';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from "../app/NotFoundHandler.react";
import urlMapping from '../app/URLMapping';
import PagingGrid from '../fw/PagingGrid.react';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'flowList.title', 'defaultMessage': 'Flows'},
});

interface ScenarioFlowListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class ScenarioFlowList extends React.Component<ScenarioFlowListProps> {

    typeName = 'flows';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const scenario = this.props.user.scenarios.edges[0].node;
        let { flows } = scenario;

        return (
            <AppPanel  breadcrumbParams={[
                {type: types['scenarios'], data: scenario}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <span style={{"float": "right"}}># {flows.edges.length}</span>

                <PagingGrid
                    columns={{
                        'name': {
                            renderLink: true,
                            render: (column, item, url, columnMapping) => {
                                if (!item.flowDef) {
                                    if (item.name) {
                                        return item.name;
                                    } else {
                                        return "-";
                                    }
                                }
                                if (item.name) {
                                    return item.flowDef.name + " - " + item.name;
                                } else {
                                    return item.flowDef.name;
                                }
                            }

                        },
                        'organisation.name': {
                            render: (column, item, url, columnMapping) => {
                                if (item && item.organisation) {
                                    return (
                                        <div>{item.organisation.name}<br/>
                                        <small>{item.organisation.adminUsers.edges.map(({node}) => node.email).join(", ")}</small>
                                        </div>
                                    );
                                } else {
                                    return (
                                        "-"
                                    );
                                }
                            }
                        },
                        'billingStatus': {
                        },
                        'createdAt': {
                            link: false,
                        },
                    }}
                    edges={flows}
                    getUrl={(flow) => {
                        let url = urlMapping.getUrl(types['flows'], 'instance-view', {id: flow.id, instance_id: flow.instance_id});
                        return url;
                    }}
                    metadata={types['flows']}
                    pageInfo={flows.pageInfo}
                    parent={this.props.user.scenario}
                    relay={this.props.relay}
                    urlMapping={urlMapping} />

            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ScenarioFlowList), (props) => {
    return props.user.scenarios.edges.length > 0;
}), {
    initialVariables: {
        first: 2000,
        after: null,
        before: null,
        last: null,
        scenarioUrlFragment: '',
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                scenarios(first: 1, urlFragment: $scenarioUrlFragment) {
                    edges {
                        node {
                            id,
                            realId,
                            name,
                            title,
                            flows(first: $first, after: $after, before: $before, last: $last) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        name,
                                        enabled,
                                        invalid,
                                        activated,
                                        deleted,
                                        instance_id,
                                        organisation_id,
                                        organisation {
                                            id,
                                            name,
                                            email,
                                            adminUsers(first: 4) {
                                                edges {
                                                    node {
                                                        id,
                                                        email,
                                                    }
                                                }
                                            }
                                        },
                                        billingStatus,
                                        flowDef_id,
                                        flowDef {
                                            id,
                                            name,
                                        },
                                        createdAt,
                                    }
                                },
                                pageInfo {
                                    hasNextPage,
                                    hasPreviousPage,
                                    startCursor,
                                    endCursor
                                }
                            }        
                        }
                    }
                }
            }
        `,
    },
});
